import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mes-documents-contractuels',
  templateUrl: './mes-documents-contractuels.component.html',
  styleUrls: ['./mes-documents-contractuels.component.scss']
})
export class MesDocumentsContractuelsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
